const SET_DEPARTS = 'SET_DEPARTS';
const SET_DICTIONARIES = 'SET_DICTIONARIES';
const SET_USERINFO = 'SET_USER_INFO';
const CLEAR_LOGININFO = 'CLEAR_LOGININFO';
const SET_USERS = 'SET_USERS';
const SET_ROLES = 'SET_ROLES';
const SET_BUSINESS = 'SET_BUSINESS';
const SET_SYSTEM = 'SET_SYSTEM';
const SET_ROLEIDS = 'SET_ROLEIDS';
const SET_ROUTERS = 'SET_ROUTERS';

export default {
  SET_DEPARTS,
  SET_DICTIONARIES,
  SET_USERINFO,
  SET_USERS,
  CLEAR_LOGININFO,
  SET_ROLES,
  SET_BUSINESS,
  SET_SYSTEM,
  SET_ROLEIDS,
  SET_ROUTERS
};



// WEBPACK FOOTER //
// ./src/store/types.js